/**
 * When the FIRST auto-renewal will be charged, for a subscription bought right
 * now.
 *
 * ⚠️ Deliberately mirrors `SubscriptionsService`'s arithmetic — plain `Date`
 * with `setMonth` / `setFullYear`, NOT luxon's `plus({ months: 1 })`.
 *
 * They disagree at month ends, which is exactly where a wrong promise is most
 * visible. Buying on 31 August, the server does `setMonth(7 + 1)` → 31
 * September → JS overflows it to **1 October**. Luxon clamps to **30
 * September**. Showing a date one day before the card is actually charged is
 * the kind of small lie that costs trust precisely in the window this line
 * exists to reassure. So the client copies the server's overflow rather than
 * doing the arguably-nicer thing.
 *
 * If the server's period maths ever changes, this must change with it — the two
 * are a pair, and nothing but this comment says so.
 */
export function nextChargeDate(billingPeriod: string, from: Date = new Date()): Date {
  const d = new Date(from);
  if (billingPeriod === 'annual') d.setFullYear(d.getFullYear() + 1);
  else d.setMonth(d.getMonth() + 1);
  return d;
}

/**
 * How many days before a renewal the reminder goes out.
 *
 * Mirrors `REMIND_WINDOW_DAYS` in `scripts/renewal-reminders.ts`, which is
 * pinned at ≥7 to satisfy the Visa/Mastercard recurring rules (the cardholder
 * must be notified at least 7 days before a charge). Quoting a smaller number
 * in the UI would understate a guarantee we are contractually keeping, and
 * quoting a larger one would be a promise the scheduler does not make.
 */
export const RENEWAL_REMINDER_DAYS = 7;
